export async function refreshAccessToken(): Promise<{ accessToken: string } | null> {
  const r = await fetch('/api/v2/auth/token/refresh', {
    method: 'POST',
    credentials: 'include',
  });
  if (!r.ok) return null;
  const data = (await r.json()) as { access_token: string; expires_in: number };
  return { accessToken: data.access_token };
}
